module.exports = __webpack_public_path__ + "static/media/history.9b42d9bf.png";